<!--
 * @Author: 
 * @Date: 2024-01-24 09:28:09
 * @LastEditors: lwk
 * @LastEditTime: 2024-02-22 11:36:41
 * @Description: 晨会/数据统计
-->
<template>
  <div class="publicStatic">
    <div>
      <el-row
        :gutter="24"
        type="flex"
        class="row-bg"
        justify="space-around"
        style="margin-bottom: 10px;"
      >
        <el-col :span="6">
          <el-row type="flex">
            <div style="margin-right: 10px;">
              <el-input
                size="mini"
                placeholder="请输入部门名称"
                v-model="form.deptName"
              ></el-input>
            </div>
            <div>
              <el-input
                size="mini"
                placeholder="请输入提交人"
                v-model="form.submitPerson"
              ></el-input>
            </div>
          </el-row>
        </el-col>
        <el-col :span="4">
          <el-select
            v-model="form.isEvaluate"
            placeholder="是否评价"
            size="mini"
            style="width: 100px;"
          >
            <el-option
              v-for="item in evaluatList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="10">
          <el-row
            :gutter="24"
            type="flex"
            class="row-bg"
            justify="space-between"
          >
            <el-date-picker
              v-model="dateTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="yyyy-MM-dd"
              :clearable="false"
            >
            </el-date-picker>
            <div>
              <el-button
                @click="searchData"
                size="mini"
                type="primary"
                icon="el-icon-search"
                >查询</el-button
              >
              <el-button
                @click="reset"
                size="mini"
                type="primary"
                icon="el-icon-search"
                >重置</el-button
              >
            </div>
          </el-row>
        </el-col>
      </el-row>
      <el-row>
        <el-table
          :data="onLineTableDataPerson"
          style="width: 100%"
          height="600"
          border
        >
          <el-table-column label="序号" type="index" width="100" align="center">
          </el-table-column>
          <el-table-column
            prop="serialNum"
            align="center"
            label="流水号"
          ></el-table-column>
          <el-table-column
            prop="showTime"
            label="日期"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="deptName"
            label="所属部门"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="submitPerson"
            label="提交人"
            align="center"
          ></el-table-column>
          <el-table-column prop="isEvaluate" label="是否已评价" align="center">
            <template slot-scope="scope">
              {{ scope.row.isEvaluate ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="viewDetail(scope.row)"
                >{{ scope.row.isEvaluate ? "查看" : "评价" }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination
            style="margin-top: 10px;"
            background
            layout="prev, pager, next"
            :total="total"
            @current-change="handlePageChange"
          >
          </el-pagination>
        </div>
      </el-row>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
      <div
        class="formBox"
        style="border-bottom: 1px solid #e6e6e6;margin-bottom: 10px;"
      >
        <div class="formItem" v-for="item in grayDataColumn" :key="item.label">
          <div class="formItem_content">
            <label class="labelItem">{{ item.label }}</label>
            <span>{{ onLinescoreData[item.prop] }}</span>
          </div>
        </div>
      </div>
      <div class="formBox">
        <div
          v-for="i in moduleList"
          :key="i.label"
          style="display: flex;justify-content: center;"
          class="formItem"
        >
          <div class="formItem_content" style="width:280px;">
            <label class="labelItem">{{ i.label }}</label>
            <el-input-number
              :disabled="dialogTitle === '查看'"
              size="small"
              v-model="onLinescoreData[i.prop]"
              :min="1"
              :max="10"
            ></el-input-number>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  getOnlinePage,
  getOnlinePageDetail,
  proceedEvaluate
} from "@/api/morningMeet";
import moment from "moment";

export default {
  name: "DataStatistical",
  data() {
    return {
      form: {
        deptName: "",
        submitPerson: "",
        isEvaluate: "",
        startDate: "",
        endDate: ""
      },
      dateTime: [],
      onLineTableDataPerson: [],
      pageType: {
        pageSize: 10,
        pageNumber: 1
      },
      total: undefined,
      dialogVisible: false,
      grayDataColumn: [
        {
          label: "流水号：",
          prop: "serialNum"
        },
        {
          label: "日期：",
          prop: "showTime"
        },
        {
          label: "提交人：",
          prop: "submitPerson"
        }
      ],
      moduleList: [
        {
          label: "平台增效：",
          prop: "ptzxScore"
        },
        {
          label: "时事新闻：",
          prop: "ssxwScore"
        },
        {
          label: "关键工作及日清：",
          prop: "gjgzScore"
        },
        {
          label: "走出去行动及成果：",
          prop: "zcqxdScore"
        },
        {
          label: "文化分享：",
          prop: "whfxScore"
        },
        {
          label: "日行一善：",
          prop: "rxysScore"
        },
        {
          label: "晨会创新：",
          prop: "chcxScore"
        },
        {
          label: "现场把控：",
          prop: "xcbkScore"
        }
      ],
      evaluatList: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 0
        }
      ],
      dialogTitle: "评价",
      onLinescoreData: {
        ptzxScore: 1,
        ssxwScore: 1,
        gjgzScore: 1,
        zcqxdScore: 1,
        whfxScore: 1,
        rxysScore: 1,
        chcxScore: 1,
        xcbkScore: 1
      }
    };
  },
  mounted() {
    this.getOnlineData();
  },
  methods: {
    searchData() {
      this.getOnlineData();
    },
    tabChange(val) {
      if (val === "manage") {
        this.getOnlineData();
        return;
      }
      this.getEmployeeDayData();
    },
    async getOnlineData() {
      this.form.startDate = this.dateTime[0];
      this.form.endDate = this.dateTime[1];
      const { code, rows, total } = await getOnlinePage({
        ...this.form,
        ...this.pageType
      });
      if (code != 0) return;
      this.onLineTableDataPerson = rows;
      this.total = total;
    },
    async viewDetail(obj) {
      if (obj.isEvaluate == 0) {
        this.dialogTitle = "评价";
        Object.keys(this.onLinescoreData).forEach(key => {
          this.onLinescoreData[key] = 1;
        });
        
        this.onLinescoreData = { ...this.onLinescoreData, ...obj };
        this.dialogVisible = true;
        return;
      }
      this.dialogTitle = "查看";
      const { code, data } = await getOnlinePageDetail({
        serialNum: obj.serialNum
      });
      if (code != 0) return;
      this.onLinescoreData = { ...data, ...obj };
      delete this.onLinescoreData.id
      this.dialogVisible = true;
    },
    handlePageChange(val) {
      this.pageType.pageNumber = val;
      this.getOnlineData();
    },
    reset() {
      Object.keys(this.form).forEach(item => {
        this.form[item] = "";
      });
      this.dateTime = ["", ""];
      this.getOnlineData();
    },
    async submit() {
      if (this.dialogTitle == "查看") {
        this.dialogVisible = false;
        return;
      }
      const { code, data } = await proceedEvaluate(this.onLinescoreData);
      if (code != 0) return;
      this.$message.success("评价成功");
      this.dialogVisible = false;
      this.getOnlineData();
    }
  }
};
</script>

<style lang="scss" scoped>
.formBox {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .formItem {
    display: flex;
    .formItem_content {
      min-width: 220px;
      padding: 3px 0;
      display: flex;
      justify-content: space-between;
      .labelItem {
      }
    }
  }
}
.grayGet {
  height: 60px;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
}
</style>



// WEBPACK FOOTER //
// src/components/MorningMeeting/OnlineEvaluation.vue